import { DataItemMap, ProductionData } from "../../types/responseTypes";

// Mock hourly production data for testing purposes
//
// son 17 horas de datos de producción REAL de un panel 
const mockHourlyData: ProductionData[] = [
  {
    collectTime: 1733194800000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 0,
      inverterYield: 0,
      power_profit: 0,
      theory_power: null,
      PVYield: 0,
      ongrid_power: 0,
      chargeCap: null,
      selfProvide: 0
    } as DataItemMap,
  },
  {
    collectTime: 1733198400000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 0,
      inverterYield: 0,
      power_profit: 0,
      theory_power: null,
      PVYield: 0,
      ongrid_power: 0,
      chargeCap: null,
      selfProvide: 0
    } as DataItemMap,
  },
  {
    collectTime: 1733202000000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 0,
      inverterYield: 0,
      power_profit: 0,
      theory_power: null,
      PVYield: 0,
      ongrid_power: 0,
      chargeCap: null,
      selfProvide: 0
    } as DataItemMap,
  },
  {
    collectTime: 1733205600000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 0,
      inverterYield: 0,
      power_profit: 0,
      theory_power: null,
      PVYield: 0,
      ongrid_power: 0,
      chargeCap: null,
      selfProvide: 0
    } as DataItemMap,
  },
  {
    collectTime: 1733209200000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 0,
      inverterYield: 0,
      power_profit: 0,
      theory_power: null,
      PVYield: 0,
      ongrid_power: 0,
      chargeCap: null,
      selfProvide: 0
    } as DataItemMap,
  },
  {
    collectTime: 1733212800000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 0,
      inverterYield: 0,
      power_profit: 0,
      theory_power: null,
      PVYield: 0,
      ongrid_power: 0,
      chargeCap: null,
      selfProvide: 0
    } as DataItemMap,
  },
  {
    collectTime: 1733216400000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 0,
      inverterYield: 0,
      power_profit: 0,
      theory_power: null,
      PVYield: 0,
      ongrid_power: 0,
      chargeCap: null,
      selfProvide: 0
    } as DataItemMap,
  },
  {
    collectTime: 1733220000000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 0.07,
      inverterYield: 0.07,
      power_profit: 12.95,
      theory_power: null,
      PVYield: 0.07,
      ongrid_power: 0,
      chargeCap: null,
      selfProvide: 0.07
    } as DataItemMap,
  },
  {
    collectTime: 1733223600000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 0.17,
      inverterYield: 0.17,
      power_profit: 28.75,
      theory_power: null,
      PVYield: 0.17,
      ongrid_power: 0.03,
      chargeCap: null,
      selfProvide: 0.14
    } as DataItemMap,
  },
  {
    collectTime: 1733227200000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 0.61,
      inverterYield: 0.61,
      power_profit: 75.05,
      theory_power: null,
      PVYield: 0.61,
      ongrid_power: 0.42,
      chargeCap: null,
      selfProvide: 0.19
    } as DataItemMap,
  },
  {
    collectTime: 1733230800000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 1.08,
      inverterYield: 1.08,
      power_profit: 133.2,
      theory_power: null,
      PVYield: 1.08,
      ongrid_power: 0.74,
      chargeCap: null,
      selfProvide: 0.34
    } as DataItemMap,
  },
  {
    collectTime: 1733234400000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 1.47,
      inverterYield: 1.47,
      power_profit: 176.55,
      theory_power: null,
      PVYield: 1.47,
      ongrid_power: 1.06,
      chargeCap: null,
      selfProvide: 0.41
    } as DataItemMap,
  },
  {
    collectTime: 1733238000000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 1.75,
      inverterYield: 1.75,
      power_profit: 197.75,
      theory_power: null,
      PVYield: 1.75,
      ongrid_power: 1.4,
      chargeCap: null,
      selfProvide: 0.35
    } as DataItemMap,
  },
  {
    collectTime: 1733241600000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 1.94,
      inverterYield: 1.94,
      power_profit: 209.5,
      theory_power: null,
      PVYield: 1.94,
      ongrid_power: 1.66,
      chargeCap: null,
      selfProvide: 0.28
    } as DataItemMap,
  },
  {
    collectTime: 1733245200000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 1.98,
      inverterYield: 1.98,
      power_profit: 231.3,
      theory_power: null,
      PVYield: 1.98,
      ongrid_power: 1.5,
      chargeCap: null,
      selfProvide: 0.48
    } as DataItemMap,
  },
  {
    collectTime: 1733248800000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 1.83,
      inverterYield: 1.83,
      power_profit: 235.05,
      theory_power: null,
      PVYield: 1.83,
      ongrid_power: 1.15,
      chargeCap: null,
      selfProvide: 0.68
    } as DataItemMap,
  },
  {
    collectTime: 1733252400000,
    stationCode: "NE=33999642",
    dataItemMap: {
      dischargeCap: null,
      radiation_intensity: null,
      inverter_power: 1.29,
      inverterYield: 1.29,
      power_profit: 188.25,
      theory_power: null,
      PVYield: 1.29,
      ongrid_power: 0.56,
      chargeCap: null,
      selfProvide: 0.73
    } as DataItemMap,
  }
];

export default mockHourlyData;